import { Modal } from 'react-bootstrap';

import { Button } from '../../../components/button';
import text from '../../../text';

type ConfirmModalProps = {
  show: boolean;
  message: string;
  loading: boolean;
  onHide: () => void;
  onConfirm: () => void;
};

// Stacked above PricingModal (z-index rules), so the shared CONFIRM_MODAL can't be used.
const ConfirmModal = ({
  show,
  message,
  loading,
  onHide,
  onConfirm,
}: ConfirmModalProps) => (
  <Modal
    centered
    show={show}
    onHide={onHide}
    className='PricingConfirmModal__root'
    backdropClassName='PricingConfirmModal__backdrop'
    dialogClassName='PricingConfirmModal'
  >
    <Modal.Header closeButton className='border-0 pb-0' />
    <Modal.Body className='text-center'>
      <h3 className='mb-3'>{text('areYouSure')}</h3>
      <p className='font-grey mb-4'>{message}</p>
      <div className='d-flex justify-content-center mt-5'>
        <Button
          variant='primary'
          loading={loading}
          onClick={onConfirm}
          style={{ width: '200px' }}
        >
          {text('proceed')}
        </Button>
      </div>
    </Modal.Body>
  </Modal>
);

export default ConfirmModal;
